import Styled from 'styled-components'


export const Container = Styled.div`
`


export const Paragraph = Styled.div`
`